(() => {
    const initThemeSwitcher = () => {
        const el = document.querySelector('.theme-switcher');

        if (!el) {
            return;
        }

        const inp = el.querySelector('input');

        if (!inp) {
            return;
        }

        inp.addEventListener('change', () => {
            document.querySelector('body').classList.toggle('dark-theme', inp.checked);
            document.querySelector('body').classList.toggle('light-theme', !inp.checked);

            document.cookie = `theme=${inp.checked ? 'dark' : 'light'}; path=/;`;
        });
    };

    initThemeSwitcher();
})();
